import { FC } from 'react';
import { Button } from '@mui/material';
import { useCSVDownloader } from 'react-papaparse';
import { AvaStore } from '@models';

type Props = {
  rows: AvaStore[];
};

export const AvaStoresListDownloadCsv: FC<Props> = ({ rows }) => {
  const { CSVDownloader } = useCSVDownloader();

  const excludeID = (rows: AvaStore[]) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    return rows.map(({ _id, address, opening_hours, skus, ...rest }) => {
      const { geo, ...addressWithoutGeo } = address || {};
      const flattenedAddress = addressWithoutGeo
        ? {
            ...addressWithoutGeo,
            lat: geo?.lat,
            lng: geo?.lng,
          }
        : {};
      const flattenedData = {
        ...rest,
        ...flattenedAddress,
      };

      if (opening_hours) {
        const openingHoursFlattened = opening_hours.reduce(
          (acc, { day, open, closed }) => ({
            ...acc,
            [`${day}_open`]: open,
            [`${day}_closed`]: closed,
          }),
          {},
        );
        return {
          ...flattenedData,
          ...openingHoursFlattened,
        };
      } else {
        return flattenedData;
      }
    });
  };

  return (
    <CSVDownloader data={() => excludeID(rows)} filename={`jimbo-ava-stores-list-export-${new Date().toISOString()}`}>
      <Button variant="contained" data-testid="ava-stores-list-download-btn">
        Download CSV
      </Button>
    </CSVDownloader>
  );
};
